<template>
  <div>

    <ed-modal 
      :modal="showModal" 
      :title="(tabela_preco ? tabela_preco.credenciada_nome+' - VALOR TOTAL DOS EXAMES: R$ '+tabela_preco.valor_total : '')" 
      width="90%"
    >
      <div slot="modal-content" v-if="tabela_preco" v-loading="parent.loadingExame">

        <ed-alert
          type="warning"
          description="Disponibilizamos abaixo a lista dos exames obrigatórios no PCMSO. Você pode escolher em qual Parceiro o exame deve ser feito."
          title="Atenção"
        />

        <ed-table
          class="mt-2"
          :tableData="tableData"
          :tableHead="tableHead"
          :tableFooter="tableFooter"
          :loadingTable="loadingTable"
          disableInputSearch
          disableCheckAll
          disabledConfigCell
        />
      </div>
  </ed-modal>

  </div>
</template>

<script>

import Rest from 'common/rest'
import Fct from 'common/fct'
import EdModal from 'common/modal'
import EdAlert from 'common/alert'
import EdTable from 'common/table'

export default {
    name: 'EmpresaCadastro',
    components:{EdModal,EdAlert,EdTable},
    mixins:[Rest,Fct],
    props:{
      parent:{
        type: Object,
        default: {}
      },
      tabela_preco:{
        type: Object,
        default: {}
      },
      showExame:{
        type: Boolean,
        default: false
      },
    },
    watch:{
      showExame(){
        this.showModal = !this.showModal;
      },
      showModal(){
      },
      tabela_preco(){
      },
      'tabela_preco.id'(){
        this.getData();
      },
      'parent.showExame'(){
        this.getData();
      },
      'parent.loadingExame'(){
      }
    },

    data () {
      return{
        showModal:false,
        loadingTable:false,
        tableHead: [
          {
            key: 'exame',
            sortable: true,
            show_rea:true,
            show_dem:true,
            show_alt:true,
            label: 'Exame',
          },
          {
            key: 'data_ultuma_consulta',
            label: 'Data Ultima Consulta',
          },
          // {
          //   key: 'valor',
          //   sortable: true,
          //   show_html:true,
          //   width:'170px',
          //   label: 'Valor (R$)',
          //   value:0,
          // },
          // {
          //   key: 'valor_servico',
          //   sortable: true,
          //   show_html:true,
          //   width:'170px',
          //   label: 'Taxa de Serviço (R$)',
          //   value:0,
          // },
          {
            key: 'valor_total',
            sortable: true,
            show_html:true,
            width:'170px',
            label: 'Valor Total (R$)',
            value:0,
          },
        ],
        tableFooter:[],
        tableData: [],
      }
    },
    beforeDestroy(){
			this.tableData = [];
		},
    created(){
    },
    mounted(){
      this.getData();
    },

    methods: {

      getData(){
        
        if(!this.tabela_preco || !this.tabela_preco.id || !this.tabela_preco.exames || !this.tabela_preco.exames.consulta)return;

        var tableData = [], tableFooter = [], total_valor_venda = 0, total_valor_servico = 0;
        this.loadingTable = true;

        //CONSULTAS
        for (let i = 0; i < this.tabela_preco.exames.consulta.length; i++) {

          const element = this.tabela_preco.exames.consulta[i];
          
          var valor_venda = null,valor_servico = null, valor_total = null;

          if(!element.id_con_rea && element.valor_venda){
            valor_venda = element.valor_venda;
          }

          if(!element.id_con_rea && element.valor_total){
            valor_total = element.valor_total;
          }

          if(!element.id_con_rea && element.valor_servico){
            valor_servico = element.valor_servico
          }

          var item = {
            id: element.id,
            exame: (element.exame ? element.exame.nome : null),
            data_ultuma_consulta: (element.dt_exame ? this.$utilidade.toDate(element.dt_exame,true) : '---')+
            (element.validade_exame>0 ? '<br><span style="color:red">Exame válido por '+element.validade_exame+' dias</span>': '')+
            (element.validade_pcmso ? '<br><span style="color:'+element.validade_pcmso_cor+'">Exame válido até '+this.$utilidade.toDate(element.validade_pcmso,true)+'</span>': ''),
            valor: (element.va == '1' ? '<img src="'+this.env.url_cs+'app/1.img/img_sof/va.png" title="Exame incluso no contrato Vida Ativa"/>' : (valor_venda ? valor_venda : '---')),
            valor_servico: (element.va == '1' ? '<img src="'+this.env.url_cs+'app/1.img/img_sof/va.png" title="Exame incluso no contrato Vida Ativa"/>' : (valor_servico ? valor_servico+' ('+element.taxa_servico+')%' : '---')),
            valor_total: (element.va == '1' ? '<img src="'+this.env.url_cs+'app/1.img/img_sof/va.png" title="Exame incluso no contrato Vida Ativa"/>' : (valor_total ? valor_total : '---')),
            _data: element,
            buttons : []
          };

          this.tableHead[1].value += this.moneyToFloat(valor_venda);
          this.tableHead[2].value += this.moneyToFloat(valor_servico);
          //this.tableHead[3].value += this.moneyToFloat(valor_total);

          tableData.push(item);
        }

      
        //DEMONSTRATIVO
        for (let i = 0; i < this.tabela_preco.exames.demonstrativo.length; i++) {

          const element = this.tabela_preco.exames.demonstrativo[i];
          
          var item = {
            id: element.id,
            exame: element.nome,
            data_ultuma_consulta: (element.dt_exame ? this.$utilidade.toDate(element.dt_exame,true) : '---'),
            valor: '---',
            valor_servico: '---',
            valor_total: '---',
            _data: element,
            buttons : []
          };

          tableData.push(item);
        }

        this.loadingTable = false;
        this.tableData = tableData;
        this.tableFooter = tableFooter;

      }
    }
}
</script>

<style lang="scss">
.active td{
  background: #fcf8e3;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// exame.vue?130b1e68